import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upArrow",
  "use": "icon-upArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-upArrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0L204.8 512h614.4L512 0zM409.6 1024h204.8V512H409.6v512z\" p-id=\"43181\" fill=\"#f4ea2a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/upArrow.svg
// module id = SpuY
// module chunks = 212